import { semverLt } from './semver-min';
import { normalizeVersionString } from './strings';

/**
 * Decide whether the app should prompt the user to self-update.
 *
 * Prompts whenever the published version is strictly newer than the
 * installed build, regardless of any release marker. This intentionally
 * has NO `-r` (release-marker) gate. A native release (Foreman 0.6.3)
 * once shipped with a plain version number and the in-app prompt
 * silently never fired. Tim's intent (2026-09-01): any newer release
 * should trigger the self-update, so the only condition is "newer".
 *
 * The installed name is normalized first (matching the historical call
 * site); the published value is passed through to `semverLt`, which
 * coerces both sides. Returns `false` on uncomparable input, preserving
 * `semverLt`'s safe default of "no upgrade available".
 */
export function shouldSuggestVersionUpgrade(
  installedVersionName: string,
  publishedVersionNumber: string
): boolean {
  const installed = normalizeVersionString(installedVersionName);
  return semverLt(installed, publishedVersionNumber);
}
